import { useQuery } from 'react-query'
import { apiGetUserById } from '../services/SettingsService'

export default (userId: number) => useQuery(['user', userId], () => apiGetUserById(userId))
